import 'whatwg-fetch';
import { debounce } from 'debounce';
import VideoPausePlay from './modules/videoPausePlay';
import EnableTabbing from './modules/enableTabbing';
import ToggleFilters from './modules/toggleEventFilters';
import CalendarDatepickk from './modules/calendarDatepickk';
import EventsStickInfo from './modules/eventsStickyInfo';
import ImageLightBox from './modules/imageLightbox';
import CalculateTrueHeight from './modules/calculateTrueHeight';
import SlideMobileFilters from './modules/slideMobileFilters';

const video = document.getElementById('content-home__video');
// eslint-disable-next-line no-unused-vars
const videoPausePlay = new VideoPausePlay(video);

EnableTabbing();
ToggleFilters();
CalendarDatepickk();
EventsStickInfo();
ImageLightBox();
SlideMobileFilters();
CalculateTrueHeight();
document.addEventListener('scroll', debounce(CalculateTrueHeight), false);
window.addEventListener('resize', debounce(CalculateTrueHeight), false);
